import React from "react";
import { Typography } from "@mui/material";

import ManagementLogo from "assets/Icons/ManagementLogo.svg";
import DataLogo from "assets/Icons/DataLogo.svg";
import FileTextLogo from "assets/Icons/FileTextLogo.svg";
import FaqLogo from "assets/Icons/FaqLogo.svg";
import DeviceLogo from "assets/Icons/DeviceLogo.svg";
import CategoryLogo from "assets/Icons/CategoryLogo.svg";
import RewardsLogo from "assets/Icons/RewardsLogo.svg";
import { useNavigate } from "react-router";
import { getLocalStorageItem } from "hooks";
import { format } from "date-fns";

const AdminPortal = () => {
  const navigate = useNavigate();

  const handleClickDashBoard = () => {
    navigate("/dashboard");
  };

  const handleClickManagementLogo = () => {
    navigate("/manage-employees");
  };

  const handleClickStatistics = () => {
    navigate(
      `/study-statistics?startDate=2023-10-01&endDate=${format(
        new Date(),
        "yyyy-MM-dd"
      )}&filter=All`
    );
  };

  const handleClickCategories = () => {
    navigate("/category-management");
  };

  const handleClickFaq = () => {
    navigate("/faq");
  };

  const handleClickDevices = () => {
    navigate("/manage-devices");
  };

  const handleClickPointsRewards = () => {
    navigate("/points-rewards");
  };

  const user = getLocalStorageItem("USER_ROLE");

  return (
    <div className="flex flex-wrap max-lg:flex-col max-lg:pt-[10%] max-lg:gap-6 gap-10 justify-center items-center m-auto h-full max-w-[1200px] py-10">
      <div item className="flex flex-col justify-center items-center">
        <div
          className="bg-[#ECF6FF] rounded-lg p-5  cursor-pointer shadow-md"
          onClick={handleClickDashBoard}
        >
          <img src={DataLogo} alt="Management Logo" />
        </div>

        <Typography className="main-tab-text" variant="h4">
          Data Dashboard
        </Typography>
      </div>
      {(user === "SUPER_ADMIN" || user === "ADMIN") && (
        <div item className="flex flex-col items-center justify-center">
          <div
            className="bg-[#ECF6FF] rounded-lg p-5  cursor-pointer shadow-md"
            onClick={handleClickManagementLogo}
          >
            <img src={ManagementLogo} alt="Management Logo" />
          </div>

          <Typography className="main-tab-text" variant="h4">
            Manage Employees
          </Typography>
        </div>
      )}
      <div item className="flex flex-col items-center justify-center">
        <div
          className="bg-[#ECF6FF] rounded-lg p-5  cursor-pointer shadow-md"
          onClick={handleClickStatistics}
        >
          <img src={FileTextLogo} alt="Management Logo" />
        </div>

        <Typography className="main-tab-text" variant="h4">
          Study Statistics
        </Typography>
      </div>
      {(user === "SUPER_ADMIN" || user === "ADMIN") && (
        <div item className="flex flex-col items-center justify-center">
          <div
            className="bg-[#ECF6FF] rounded-lg p-5 cursor-pointer shadow-md"
            onClick={handleClickCategories}
          >
            <img src={CategoryLogo} alt="Manage Categories" />
          </div>
          <Typography className="main-tab-text" variant="h4">
            Manage Categories
          </Typography>
        </div>
      )}
      {(user === "SUPER_ADMIN" || user === "ADMIN") && (
        <div item className="flex flex-col items-center justify-center">
          <div
            className="bg-[#ECF6FF] rounded-lg p-5 cursor-pointer shadow-md"
            onClick={handleClickFaq}
          >
            <img src={FaqLogo} alt="Manage FAQs" />
          </div>
          <Typography className="main-tab-text" variant="h4">
            Manage FAQs
          </Typography>
        </div>
      )}
      {(user === "SUPER_ADMIN" || user === "ADMIN") && (
        <div item className="flex flex-col items-center justify-center">
          <div
            className="bg-[#ECF6FF] rounded-lg p-5 cursor-pointer shadow-md"
            onClick={handleClickDevices}
          >
            <img src={DeviceLogo} alt="Manage Devices" />
          </div>
          <Typography className="main-tab-text" variant="h4">
            Manage Devices
          </Typography>
        </div>
      )}
      <div item className="flex flex-col items-center justify-center">
        <div
          className="bg-[#ECF6FF] rounded-lg p-5 cursor-pointer shadow-md"
          onClick={handleClickPointsRewards}
        >
          <img src={RewardsLogo} alt="Points & Rewards" />
        </div>
        <Typography className="main-tab-text" variant="h4">
          Points & Rewards
        </Typography>
      </div>
    </div>
  );
};

export default AdminPortal;
